import Promise from 'bluebird';
import _ from 'lodash';
import worldMap from '../../core/map';
import { pinBuilder } from '../../core/map/pinBuilder';
import ColorBrewer from '../../core/tools/colorbrewer';
import environment from '../../environment';

import HaloLayer from '../HaloLayer';
import Leaflet from '../Leaflet';

const LayerControls = (name) => require('../../controls').get(name);
const get = (name, currentMap = worldMap.getCurrent()) => {
  return require('../index').default.get(name, currentMap);
};

const contextType = 'MulticriteriaAfterSales';
export const getLegend = ({ ScoreMin, ScoreMax }) => {
    return `Score: ${ScoreMin} a ${ScoreMax}`;
};

class MulticriteriaAfterSalesLayer {
  constructor(currentMap) {
    const mapId = +currentMap._id;

    const clusterImage = new Image();
    clusterImage.src = `${environment.get('IMAGES_HOST')}/icon_marker_greenfield.png`;

    const onClick = (feature, layer) => {
      LayerControls(contextType).highlight(layer);
      LayerControls(contextType).show({
        show: true,
        id: feature.properties.Id
      });

      return new HaloLayer(currentMap, layer, feature, contextType, 'points');
    };

    const clusterTemplate = (cluster) => {
      const data = { value: cluster.getChildCount() };
      return pinBuilder.create.pin.imageWithValue(data, clusterImage);
    };

    const onComplete = (features) => {
        return LayerControls(contextType).show({
            show: false,
            refresh: true
        });
    };

    return new Leaflet.GeoJSONLayer({
      map: currentMap,
      remote: {
        method: 'GET',
        url: `${environment.get('API_HOST')}/aftersales/multicriterias`,
        params: {
        }
      },
      scaleRange: [5, 20],
      cache: false,
      filter: {
        location: true
      },
      showAll: false,
      autofocus: false,
      uniqueField: 'Id',
      sort: 'ScoreMin',
      click: onClick,
      done: onComplete,
      legend: {
        title: 'Multicritério',
        text: getLegend,
        icon: (prop) => {
            return `${environment.get('IMAGES_HOST')}/pin_pi_${prop.Color}_xs.png`;
        },
      },
      type: 'cluster',
      symbology: {
        type: 'polymorph',
        cluster: {
          template: clusterTemplate
        },
        heat: {
          theme: ColorBrewer.getHeatColors('Greens')
        },
        style: {
            icon: {
                iconUrl: 'asdasdasdasda',
                getUrl: MulticriteriaAfterSalesLayer.getApplicatorUrlIcon(contextType),
                iconSize: [47, 60], // size of the icon
                iconAnchor: [25, 60],
                labelAnchor: [25, -32],
                className: 'store-marker-icon',
            },
            riseOnHover: true
        }
      }
    });
  }

  static getApplicatorUrlIcon = contextType => {
      return (data) => {
          const { imgSuffix } = get(contextType).options.symbology.style.icon;
          const { Color } = data;
          return `${environment.get('IMAGES_HOST')}/pin_pi_${Color}${(imgSuffix || '')}.png`;
      };
  }
}

export default MulticriteriaAfterSalesLayer;



// WEBPACK FOOTER //
// ./src/scripts/layers/AfterSales/MulticriteriaAfterSalesLayer.js